import { Slider as SliderPrimitive } from "@base-ui/react/slider";
import * as React from "react";

import { cn } from "../../utils/cn";

function Slider({
    className,
    defaultValue,
    value,
    min = 0,
    max = 100,
    ...props
}: SliderPrimitive.Root.Props): React.ReactElement {
    const _values = Array.isArray(value)
        ? value
        : Array.isArray(defaultValue)
          ? defaultValue
          : [min, max];

    return (
        <SliderPrimitive.Root
            data-slot="slider"
            defaultValue={defaultValue}
            value={value}
            min={min}
            max={max}
            thumbAlignment="edge"
            className={cn(
                "data-horizontal:w-full data-vertical:h-full",
                className
            )}
            {...props}
        >
            <SliderPrimitive.Control
                data-slot="slider-control"
                className="relative flex w-full touch-none items-center select-none data-disabled:opacity-50 data-vertical:h-full data-vertical:min-h-40 data-vertical:w-auto data-vertical:flex-col"
            >
                <SliderPrimitive.Track
                    data-slot="slider-track"
                    className="relative grow overflow-hidden rounded-full bg-surface-sunken select-none data-horizontal:h-1.5 data-horizontal:w-full data-vertical:h-full data-vertical:w-1.5"
                >
                    <SliderPrimitive.Indicator
                        data-slot="slider-range"
                        className="bg-accent select-none data-horizontal:h-full data-vertical:w-full"
                    />
                </SliderPrimitive.Track>
                {Array.from({ length: _values.length }, (_, index) => (
                    <SliderPrimitive.Thumb
                        key={index}
                        data-slot="slider-thumb"
                        className={cn(
                            "relative block size-4 shrink-0 rounded-full border border-accent bg-paper-200 shadow transition-[color,box-shadow] select-none",
                            "after:absolute after:-inset-2",
                            "disabled:pointer-events-none disabled:opacity-50"
                        )}
                    />
                ))}
            </SliderPrimitive.Control>
        </SliderPrimitive.Root>
    );
}

export { Slider };
